import { render, staticRenderFns } from "./SimpleCartBody.vue?vue&type=template&id=b47f524c&"
import script from "./SimpleCartBody.vue?vue&type=script&lang=js&"
export * from "./SimpleCartBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports